import { useEffect, useMemo, useState } from 'react';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import { ITreeNode } from '../../TreeView/TreeItem';
import TreeView from '../../TreeView/TreeView';
import { IPageElementModalSelection } from './PageElementModalDefinitions';

interface IPageElementContractNumberProps {
    selection: IPageElementModalSelection;
    contracts: number[];
    handleContractSelect: (selected: number) => void;
    track: TrackingEvent;
}

const PageElementContractNumber: React.FC<IPageElementContractNumberProps> = (props) => {
    const [translations] = useLanguage();
    const [selectedContractNumber, setSelectedContractNumber] = useState<number | null>();

    useEffect(() => {
        if (!props.selection.contractNumber) {
            return;
        }

        setSelectedContractNumber(props.selection.contractNumber);
    }, [props.selection.contractNumber]);

    const treeNodes: ITreeNode[] = useMemo(() => {
        const contractNumbers = Array.from(new Set(props.contracts));
        return contractNumbers.map((contractNumber, index) => ({
            id: `${contractNumber}`,
            name: `${translations.words.contract} ${contractNumber}`,
            value: `${contractNumber}`,
            parentId: '',
            parentValue: '',
            column: 'left',
            selectedProduct: contractNumber === +selectedContractNumber!,
            expanded: false,
            order: index,
            displayOrder: index,
            children: [],
        }));
    }, [props.contracts, selectedContractNumber]);

    const handleSelect = (event: React.MouseEvent<HTMLElement>) => {
        const { id } = event.currentTarget;
        const node = treeNodes.find((n) => n.id === id);
        if (node?.id) {
            props.handleContractSelect(+node.value);
        }
    };

    return <TreeView data={treeNodes} searchTerm="" handleSelect={handleSelect} disabledNodes={[]} track={props.track} />;
};

export default PageElementContractNumber;
